import { TFunction } from 'i18next'

const MINUTE_PATTERN = /^(min|mins|minute|minutes|m)$/i
const HOUR_PATTERN = /^(h|hr|hrs|hour|hours)$/i

const getLocalizedUnit = (unit: string, t: TFunction) => {
  if (MINUTE_PATTERN.test(unit)) return t('timeUnitMinutesShort', 'min')
  if (HOUR_PATTERN.test(unit)) return t('timeUnitHoursShort', 'h')

  return unit
}

export const getLocalizedDurationLabel = (label: string, t: TFunction) => {
  const normalizedLabel = label?.trim().replace(/\s+/g, ' ')
  if (!normalizedLabel) return label

  const upToMatch = normalizedLabel.match(
    /^(up to)\s+(\d+(?:[.,]\d+)?)\s*(min|mins|minute|minutes|m|h|hr|hrs|hour|hours)\.?$/i,
  )
  if (upToMatch) {
    return t('durationUpToLabel', 'Up to {{value}} {{unit}}', {
      value: upToMatch[2],
      unit: getLocalizedUnit(upToMatch[3], t),
    })
  }

  const overMatch = normalizedLabel.match(
    /^(over)\s+(\d+(?:[.,]\d+)?)\s*(min|mins|minute|minutes|m|h|hr|hrs|hour|hours)\.?$/i,
  )
  if (overMatch) {
    return t('durationOverLabel', 'Over {{value}} {{unit}}', {
      value: overMatch[2],
      unit: getLocalizedUnit(overMatch[3], t),
    })
  }

  const rangeMatch = normalizedLabel.match(
    /^(\d+(?:[.,]\d+)?)\s*-\s*(\d+(?:[.,]\d+)?)\s*(min|mins|minute|minutes|m|h|hr|hrs|hour|hours)\.?$/i,
  )
  if (rangeMatch) {
    return `${rangeMatch[1]}-${rangeMatch[2]} ${getLocalizedUnit(rangeMatch[3], t)}`
  }

  return label
}
